import { SET_CATEGORY, GET_CATEGORY } from "./actionType";

export const setCategory = (categoryData) => {
  return {
    type: SET_CATEGORY,
    payload: categoryData,
  };
};

export const getCategory = (categoryData) => {
  return {
    type: GET_CATEGORY,
    payload: categoryData,
  };
};
